enum StatsDataType {
  COLLECTION = "c",
  FRAME = "f"
}

export default StatsDataType;